import { otto } from "@gr-exports/async/nexus";
import { hashParams, searchParams } from "../data/params";
import type { StateManaged } from "../data/state.types";
import type { NavigationParameters, ParameterRecord } from "../data/params.types";
import { asyncScope } from "./utils";
import { sanitizeState } from "../data/state";

const log = asyncScope.scope("navigation");

export const { current, currentHash, currentSearch, currentState, currentUrl } = otto.navigation;

/**
 *
 *
 */
export function getCurrentNavigation(
  fromUrl?: string | URL | null | undefined,
  hashFilter?: string[],
  searchFilter?: string[],
): readonly [
  URL: URL,
  state: StateManaged,
  hash: NavigationParameters<ParameterRecord>,
  search: NavigationParameters<ParameterRecord>,
] {
  const url = new URL(fromUrl || location.href, window.location.origin);
  const state = sanitizeState(history.state);
  const hash = hashParams(url, hashFilter);
  const search = searchParams(url, searchFilter);

  return [url, state, hash, search] as const;
}

export function dispatchNavigationEvents(
  data: ReturnType<typeof getCurrentNavigation>,
  info: unknown,
): void {
  const [url, state, hash, search] = data;

  current.set({ url, state, hash, search, info });
  currentUrl.set(url);
  currentState.set(state);
  currentHash.set(hash);
  currentSearch.set(search);
}

let navigationInfo: unknown = undefined;
export const provideNavigationInfo = (info: unknown): void => {
  navigationInfo = info;
};

export function initNavigationEvents(): void {
  window.addEventListener("popstate", (ev) => {
    log.info("incomming popstate event", ev.state);
    /*                                                          */
    dispatchNavigationEvents(getCurrentNavigation(), navigationInfo);
    navigationInfo = undefined;
  });
}
